<template>
  <van-popup 
    v-model="dialogVisible" 
    position="center"
    :style="{ borderRadius: '16px', overflow: 'hidden' }"
    :close-on-click-overlay="false"
    :lock-scroll="true"
  >
    <div class="review-dialog" @touchmove.stop>
      <div class="dialog-content">
        <div class="dialog-title">请确认申请阅卷，确认后请耐心等待复议机关审批。</div>
        <div class="form-item">
          <div class="form-label">
            <span class="required">*</span>
            <span class="label">请填写需要查阅内容，申请理由等</span>
          </div>
          <div class="textarea-wrapper" @touchmove.stop>
            <textarea
              v-model="content"
              class="form-textarea"
              placeholder=""
              :maxlength="maxLength"
              @input="onContentInput"
            ></textarea>
            <div class="char-count">{{ contentLength }}/{{ maxLength }}字</div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <van-button class="dialog-btn cancel-btn" @click="onCancel">取消</van-button>
        <van-button class="dialog-btn confirm-btn" @click="onConfirm">确定</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Api from '@api/api'
import { Toast } from 'vant'

export default {
  name: 'ReviewApplication',
  props: {
    caseOrderNo: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      dialogVisible: false,
      content: '',
      contentLength: 0
    }
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true
    },
    
    // 输入内容变化
    onContentInput() {
      this.contentLength = this.content.length
    },
    
    // 取消按钮
    onCancel() {
      this.content = ''
      this.contentLength = 0
      this.dialogVisible = false
    },
    
    // 确定按钮
    async onConfirm() {
      // 验证必填
      if (!this.content || !this.content.trim()) {
        Toast('请填写需要查阅内容,申请理由等')
        return
      }
      
      // 验证案件流水号
      if (!this.caseOrderNo) {
        Toast('案件流水号不能为空')
        return
      }
      
      try {
        Toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0
        })
        
        // 调用接口提交申请
        const response = await Api.submitReviewApply({
          caseOrderNo: this.caseOrderNo,
          applyReason: this.content.trim()
        })
        
        Toast.clear()
        
        if (response.data.code == 0) {
          Toast.success('申请阅卷成功')
          
          // 触发确认事件
          this.$emit('confirm', {
            content: this.content.trim()
          })
          
          // 重置表单
          this.content = ''
          this.contentLength = 0
          this.dialogVisible = false
        } else {
          Toast(response.data.msg || '申请失败')
        }
      } catch (error) {
        Toast.clear()
        console.error('申请阅卷失败', error)
        Toast('申请失败，请重试')
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        // 关闭时重置表单
        this.content = ''
        this.contentLength = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.review-dialog {
  width: 680px;
  max-width: 90vw;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.dialog-content {
  padding: 30px 20px 20px;
}

.dialog-title {
  font-size: 16px;
  color: #333;
  line-height: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.form-item {
  width: 100%;
}

.form-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.required {
  color: #ff4d4f;
  margin-right: 4px;
}

.label {
  color: #2D7DFB;
}

.textarea-wrapper {
  position: relative;
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background-color: #fff;
  min-height: 200px;
}

.form-textarea {
  width: 100%;
  height: 200px;
  max-height: 200px;
  min-height: 200px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  line-height: 22px;
  border: none;
  background-color: transparent;
  overflow-y: auto;
  overflow-x: hidden;
  word-wrap: break-word;
  word-break: break-all;
  display: block;
  resize: none;
}

.char-count {
  position: absolute;
  right: 15px;
  bottom: 15px;
  font-size: 12px;
  color: #999;
  pointer-events: none;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 0 4px;
}

.dialog-footer {
  display: flex;
  padding: 10px 20px 20px;
  gap: 15px;
}

.dialog-btn {
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 6px;
}

.cancel-btn {
  color: #666;
  background-color: #fff;
  border: 1px solid #666;
}

.confirm-btn {
  color: #fff;
  background-color: #2D7DFB;
  border: none;
}
</style>

